import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../services/alerts.service';
import { AlbumsService } from '../../services/albums.service';
import { SuggestService } from '../../services/suggest.service';
import { UserService } from '../../services/user.service';

/**
 * Component for sharing an individual album.
 */
@Component({
	selector: 'album-share',
	templateUrl: './album-share.component.html',
	styleUrl: './album-share.component.css'
})
export class AlbumShareComponent implements OnInit {
	@Input() album: any;
	
	private MIN_TERM_LEN: number = 3;

	LOCALIZATION: any;
	userPermissions: { [key: string]: any } = {};

	input = {
		suggestUser: "",
		usersToSubmit: [] as { id: number; displayName: string; add: boolean }[],
		suggestions: [] as { firstName: string; lastName: string; email: string; id: number; displayName: string; add: boolean }[],
		isPublic: false
	};

	constructor(
		private userService: UserService,
		private alertsService: AlertsService,
		private albumsService: AlbumsService,
		private suggestService: SuggestService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.userPermissions = this.userService.getUserPermissionsMap();
		
		this.retrieveAlbumShareList();
	}

	/**
	 * Gets the album share information, including users and public status.
	 */
	retrieveAlbumShareList(): void {
		this.albumsService.getAlbum(this.album.id).then(
			(album: any) => {
				this.album = album;
				this.input.isPublic = this.album.public;
				this.input.usersToSubmit = this.album.albumRestrictions.filter((restriction: any) => {
					return restriction.user;
				}).map((restriction: any) => {
					return {
						id: restriction?.userId,
						displayName: `${restriction.user?.name || "User Not In Domain"} (${restriction.user?.email || ''})`
					};
				})
			},
			(err: any) => {
				console.error(err);
			}
		);
	}

	/**
	 * Updates the shared users list for the album.
	 */
	shareAlbum(): void {
		let users = [];
		if (this.input.isPublic) {
			users.push(-1);
		}
		else {
			users = this.input.usersToSubmit.map((user: any) => {
				return user.id
			});
		}

		this.albumsService.addAlbumShare(this.album.id, users).then(
			(response: any) => {
				this.alertsService.success({
					message: "Updated the album shares."
				});
				//				this.input.suggestUser = '';
				//				this.retrieveAlbumShareList();
				this.proceed();
			},
			(err: any) => {
				console.error("Failed to share album", err);
				this.alertsService.error({
					title: "Update Failed",
					message: err
				});
			}
		);
	}

	/**
	 * Removes the selected user from the list of potential new shares.
	 */
	removeUserInSubmit(index: number): void {
		let removeUser = this.input.usersToSubmit.splice(index, 1)[0];
		if (!removeUser?.add) {
			this.albumsService.removeAlbumShare(this.album.id, undefined, removeUser.id).then(
				(response: any) => {
					this.alertsService.success({
						message: `The user: ${removeUser.displayName} is removed from the list`
					})
				},
				(err: any) => {
					this.alertsService.error({
						title: `Could not remove user(${removeUser.displayName}).`,
						message: err
					});
					this.input.usersToSubmit.splice(index, 0, removeUser);
				}
			);
		}
	}

	onSuggestTermChange(newValue: string): void {
		this.getUserSuggestions(newValue);
	}

	getUserSuggestions(term: string) {
		if (term && term.length >= this.MIN_TERM_LEN) {
			this.suggestService.getUserSuggestions(term).then((suggestions) => {
				this.input.suggestions = suggestions.filter((suggestion: any) => {
					return !this.input.usersToSubmit?.find((user) => user.id === suggestion.id)
				})
			})
		}
		else {
			this.input.suggestions = [];
		}
	}

	/**
	 * Event handler for selecting a user from the typeahead.
	 */
	addUserToSuggestion(event: any): void {
		let selectedUser = event;
		console.log('User selected:', selectedUser);

		if (!this.input.usersToSubmit.find((user) => user.id === selectedUser.id)) {
			let fullName = `${selectedUser.firstName || 'No First Name'} ${selectedUser.lastName || 'No Last Name'}`;
			this.input.usersToSubmit.push({
				id: selectedUser.id,
				displayName: `${fullName} (${selectedUser.email || 'No Email'})`,
				add: true
			});
			this.input.suggestUser = "";
			this.input.suggestions = [];
		}
	}

	/**
	 * Handles key press to trigger user selection.
	 */
	onUserSuggestKeyUp(event: KeyboardEvent): void {
		if (event.keyCode === 13) {
			const user = this.input.suggestions.find((user) =>
				user.displayName.toLowerCase() === this.input.suggestUser.toLowerCase()
			);
			if (user) {
				this.addUserToSuggestion({ item: user });
			}
		}
	}

	/**
	 * Closes the modal, returning a result of ok and payload.
	 */
	proceed(): void {
		let caller = {
			callerName: 'shareAlbum'
		};

		this.ngbmodalService.close({
			result: { answer: 'ok', caller: caller },
			timestamp: new Date(),
		});
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
